import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { UserIndexPage } from './user-index';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
	declarations: [
		UserIndexPage,
	],
	imports: [
		ComponentsModule,
		IonicPageModule.forChild(UserIndexPage),
	],
})
export class UserIndexPageModule {}



// WEBPACK FOOTER //
// ./src/pages/user-index/user-index.module.ts